const keyMirror = arr => arr.reduce((o, v) => ({[v]: v, ...o}), {});

export default (...values) =>
  Object.freeze(Object.assign(keyMirror(values), {values: [...values]}));
